import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import MainDashboard from "../pages/Dasboard/MainDashboard";
import AppointmentRequest from "../pages/Appointment/AppointmentRequest";
import AppointmentSchedule from "../pages/Appointment/AppointmentSchedule";
import VisitConfirmation from "../pages/Appointment/VisitConfirmation";
import TokenGeneration from "../pages/Appointment/TokenGeneration";
import UserList from "../pages/SuperAdminPages/TvScreen";
import UserDetails from "../pages/SuperAdminPages/UserDetails";
import TvScreen from "../pages/SuperAdminPages/TvScreen";
import AppointmentFixed from "../pages/Appointment/AppointmentFixed";
import AppointmentCompleted from "../pages/Appointment/AppointmentCompleted";
import CreateAppointment from "../pages/Appointment/CreateAppointment";
import PanditJiScreen from "../pages/SuperAdminPages/PanditJiScreen";
function SuperAdminRoutes() {
  return (
    <Routes>
      {/* Dashboard Routes Statred */}
      <Route path="/" element={<MainDashboard/>} />
      <Route path="/tv-screen" element={<TvScreen/>} />
      <Route path="/user-management" element={<PanditJiScreen/>} />
      <Route path="/user-details/:id" element={<UserDetails/>} />
      <Route path="/appointment-request" element={<AppointmentRequest />} />
      <Route path="/appointment-schedule" element={<AppointmentSchedule />} />
      <Route path="/visit-confirmation" element={<VisitConfirmation />} />
      <Route path="/appointment-fixed" element={<AppointmentFixed />} />
      <Route path="/appointment-completed" element={<AppointmentCompleted />} />
      <Route path="/create-appointment" element={<CreateAppointment />} />
    </Routes>
  );
}

export default SuperAdminRoutes;
